import {BillingTransaction} from "../../../models";
import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";

/**
 * @class PaymentFailurePmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<BillingTransaction>}
 */
export class PaymentFailurePmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/payment-failure';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BillingTransaction}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BillingTransaction(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/payment-failure.service.js